import ComponentElement from 'components/component-element';
import Swiper from 'vendor_components/swiper.min';
import TabsComponent from 'components/tabsComponent';
import {checkFavoriteList} from 'methods/utils';

function SelectionsTabSlider($element, options = {}) {
    ComponentElement.call(this, $element, options);

    this.$tabsButtons    = this.$element.querySelectorAll('.Selections__tab');
    this.$tabsContainers = this.$element.querySelectorAll('.Selections__wrapper');
    this.$tabsSwiper     = this.$element.querySelector('.js-tabsSwiper');

    new TabsComponent({
        'container': this.$element,
        'navigation': this.$tabsButtons,
        'item': this.$tabsContainers,
    }, {
        'onChange': () => {
            this.initTabSlider();
        },
    });

    this.initTabSlider();

    setTimeout(() => {
        new Swiper(this.$tabsSwiper, {
            slidesPerView: 'auto',
            spaceBetween: 0,
        });
    }, 1000);

    checkFavoriteList();
}

SelectionsTabSlider.prototype = Object.create(ComponentElement.prototype);
Object.defineProperty(SelectionsTabSlider, 'constructor', {
    value: SelectionsTabSlider,
    writable: true,
    enumerable: false,
});

SelectionsTabSlider.prototype.setOptions = function(options) {
    ComponentElement.prototype.setOptions.call(this, Object.assign({
        tab: {
            swiper: {
                //
            },
        },
    }, options));
}

SelectionsTabSlider.prototype.getActiveTab = function() {
    return [...this.$tabsContainers].find($container => $container.classList.contains('is-active'));
}

SelectionsTabSlider.prototype.initTabSlider = function() {
    this.$tabsContainers.forEach($container => {
        const $swiperContainer = $container.querySelector('.Selections__list');
        if ($swiperContainer.swiper) {
            $swiperContainer.swiper.destroy()
        };
    });

    const $activeTab = this.getActiveTab();
    const $list = $activeTab.querySelector('.Selections__list');

    new Swiper($list, {
        slidesPerView: 'auto',
        spaceBetween: 8,
        speed: 300,
        navigation: {
            prevEl: this.$element.querySelector('.Selections__prev'),
            nextEl: this.$element.querySelector('.Selections__next'),
        },
        pagination: {
            enabled: true,
            type: 'bullets',
            el: $activeTab.querySelector('.js-selectionsPagination'),
        },
        breakpoints: {
            1024: {
                slidesPerView: 4,
                spaceBetween: 20,
                pagination: {
                    enabled: false,
                    el: null,
                },
            }
        },
        ...this.options.tab.swiper,
    });

    if (this.observer) {
        this.observer.disconnect();
    }

    if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(this._onIntersectionObserverObserve.bind(this), {
            root: $activeTab,
        });
    }

    $activeTab.querySelectorAll('img[data-src]').forEach($img => this._observeOrLoad($img));
}

SelectionsTabSlider.prototype._observeOrLoad = function($img) {
    if (!this.observer) {
        this._lazyLoad($img);
        return;
    }

    this.observer.observe($img);
}

SelectionsTabSlider.prototype._lazyLoad = function($img) {
    $img.src = $img.dataset.src;
    delete $img.dataset.src;
}

SelectionsTabSlider.prototype._onIntersectionObserverObserve = function(entries, observer) {
    entries
        .filter(entry => entry.isIntersecting)
        .forEach(entry => {
            this._lazyLoad(entry.target);
            observer.unobserve(entry.target);
        });
}

export default SelectionsTabSlider;
